/**
 * Product FAQs - Clean implementation
 * This script provides a clean implementation of the FAQ popup functionality
 * with smooth accordion animations
 */
(function () {
  // Execute when DOM is fully loaded
  function initFAQ() {

    // Find all FAQ buttons
    const faqButtons = document.querySelectorAll('.product-faqs__button');
    if (faqButtons.length === 0) return;

    // Find the modal
    const faqModal = document.getElementById('ProductFaqsModal');
    if (!faqModal) return;

    const closeButton = faqModal.querySelector('.product-faqs__close');

    // Initialize accordions
    initAccordions();

    // Add click event to FAQ buttons
    faqButtons.forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openFaqModal();
      });
    });

    // Add click event to close button
    if (closeButton) {
      closeButton.addEventListener('click', closeFaqModal);
    }

    // Close modal when clicking outside
    faqModal.addEventListener('click', function (event) {
      if (event.target === faqModal) {
        closeFaqModal();
      }
    });

    // Close modal with Escape key
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && faqModal.classList.contains('is-open')) {
        closeFaqModal();
      }
    });

    /**
     * Initialize accordion functionality
     */
    function initAccordions() {
      const allDetails = faqModal.querySelectorAll('details');

      allDetails.forEach(details => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('.collapsible__content');
        const caret = details.querySelector('.icon-caret');

        if (!summary || !content || !caret) return;

        // Store the content height for animations
        const contentHeight = content.scrollHeight;

        // Set initial state
        if (details.hasAttribute('open')) {
          caret.style.transform = 'rotate(180deg)';
          content.style.height = contentHeight + 'px';
        } else {
          content.style.height = '0px';
        }

        // Add click event
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          toggleAccordion(details, content, caret, contentHeight);
        });
      });
    }

    /**
     * Toggle accordion open/closed state
     */
    function toggleAccordion(details, content, caret, contentHeight) {
      const isOpen = details.hasAttribute('open');

      if (isOpen) {
        // Close accordion
        caret.style.transform = 'rotate(0deg)';
        content.style.height = '0px';

        // Remove open attribute after animation
        setTimeout(() => {
          details.removeAttribute('open');
        }, 300);
      } else {
        // Open accordion
        details.setAttribute('open', '');
        caret.style.transform = 'rotate(180deg)';

        // Trigger reflow to ensure animation works
        content.offsetHeight;

        // Set height to content height
        content.style.height = contentHeight + 'px';
      }
    }

    /**
     * Open the FAQ modal
     */
    function openFaqModal() {
      // Store current scroll position
      const scrollY = window.scrollY;
      document.body.setAttribute('data-scroll-position', scrollY);

      // Prevent body scrolling
      document.body.classList.add('overflow-hidden');

      // Show the modal
      faqModal.classList.add('is-open');

      // Focus on the close button
      if (closeButton) {
        setTimeout(() => closeButton.focus(), 100);
      }
    }

    /**
     * Close the FAQ modal
     */
    function closeFaqModal() {
      // Start closing animation
      faqModal.classList.add('is-closing');

      setTimeout(() => {
        // Get the stored scroll position
        const scrollY = parseInt(document.body.getAttribute('data-scroll-position') || '0');

        // Allow body scrolling
        document.body.classList.remove('overflow-hidden');

        // Restore scroll position
        window.scrollTo(0, scrollY);

        // Hide the modal
        faqModal.classList.remove('is-open');
        faqModal.classList.remove('is-closing');
      }, 300);
    }
  }

  // Initialize when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQ);
  } else {
    initFAQ();
  }
})();
